// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
// Sibling imports
const contentAddModalActions = require('./actions')
const ContentAddModal = require('./component-dumb')
const selectors = require('./selectors')
const promoSelectors = require('client-v2/common/containers/promo-badge/selectors')

function mapStateToProps(state) {
  const promoForIdSelector = promoSelectors.createPromoForIdSelector()
  if (!selectors.isVisible(state)) {
    return { isVisible: false }
  }
  return {
    // Flags
    isArticleLoading: selectors.isArticleLoading(state),
    isMobile: selectors.isMobile(state),
    isSubmitPending: selectors.isSubmitPending(state),
    isUrlInvalid: selectors.isUrlInvalid(state),
    isVisible: true,
    // Values
    article: selectors.article(state),
    downloadHref: promoSelectors.browserPromoSelector(state) || promoForIdSelector(state, 'chrome'),
    url: selectors.url(state)
  }
}

const mapDispatchToProps = {
  fetchArticle: contentAddModalActions.fetchArticle,
  onDismiss: contentAddModalActions.hide,
  onUrlSubmit: contentAddModalActions.submit,
  onUrlTextChange: contentAddModalActions.setUrlText
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      ContentAddModal
    )
  )
)
